import { http } from '../axios';
import { shopPrefix } from '../../config';

export async function sendForApproval({ listId, email }: { listId: string; email: string }) {
    await http.get(`${shopPrefix}/v1/selectionlists/:listId/approverequest`, {
        pathParams: { listId },
        params: { userEmail: email }
    });
}
